import React, { useEffect } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import * as source from "sources/books/news";
import Form from "./form";
import List from "./list";
import Show from "./show";

const News = (props) => {
    useEffect(() => {
        return () => props.clearParams("news");
    }, []);

    const { match, location, history } = props;
    const rootUrl = `${match.path}/list`;
    const back = () => history.push(rootUrl);
    return (
        <div className="page-content">
            <Switch location={location}>
                <Route exact path={`${match.path}/`} render={() => <Redirect to={rootUrl} />} />
                <Route
                    exact
                    path={rootUrl}
                    render={() => (
                        <List
                            {...props}
                            isTable
                            transition="full"
                            title="Новости"
                            nofilter
                            createBtnText="Создать новость"
                        />
                    )}
                />
                <Route
                    path={`${rootUrl}/:id`}
                    render={(rest) => <Show {...rest} transition="full" title="Новость" back={back} source={source} />}
                />
                <Route
                    path={`${match.path}/new`}
                    render={() => <Form {...props} title="Создать новость" back={back} submit={source.apply} />}
                />
            </Switch>
        </div>
    );
};

export default News;
